import { IconEyes, IconSparkles } from '@backmarket/design-system'

export const PICKER_ICONS = {
  IconEyes,
  IconSparkles,
}
